import { M8Product } from 'services/production/types';
import { Product } from 'types/state';
import { normalizeM8Price } from 'services/production/utils/normalizeM8Price';

export const normalizeM8CalculationComponent = (component: M8Product) => ({
  toProduct(): Product {
    return {
      id: component.id,
      type: component.productType,
      name: component.name,
      status: 'ACTIVE',
      createdAt: component.createdOn || null,
      defaultAmount: component.defaultCountValue,
      defaultPartnerComission: component.defaultPartnerComission,
      activeTariff: component.currentPrice
        ? normalizeM8Price(component.currentPrice).toTariff()
        : null,
      latestTariff: component.lastPrice
        ? normalizeM8Price(component.lastPrice).toTariff()
        : null,
    };
  },
});
